import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/competition-stacking/actions';
import NumberHelper from 'helpers/number-helper';

class Exposure extends Component {
    constructor(props) {
        super(props);
        this.isValueBeingChanged = false;
        this.state = {
            value: '',
        };
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({value});
    }

    onBlur(rawValue) {
        const value = NumberHelper.prepareInt(rawValue, '').limitByRange(0, 100, 0, 100).get();

        this.setState({value});
        this.isValueBeingChanged = false;

        this.props.dispatch(Action.do('setExposure', this.props.itemId, value));
    }

    getActualValue() {
        if (this.isValueBeingChanged) {
            return this.state.value;
        }

        const {stacking, itemId} = this.props;
        const stackItem = stacking.getItemById(itemId);

        return stackItem.getExposure();
    }

    render() {
        return (
            <div className="percent-in">
                <input
                    type="text"
                    className="form-control input-sm"
                    value={this.getActualValue()}
                    onBlur={(e) => this.onBlur(e.target.value)}
                    onChange={(e) => this.onChange(e.target.value)}
                />
                <span className="percent">%</span>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {competitionStacking} = state;
    return {
        stacking: competitionStacking,
    };
}

export default connect(mapStatesToProps)(Exposure);
